import { listBookmarks, removeBookmark } from "@/api";
import type {
  DataTablePageOptions,
  DataTablePageReq,
  DataTablePageResp,
} from "@carbon6/c6-frontend-design";
import { DatasetCriteriaTableSource } from "./DatasetCriteriaTableSource";
import {
  createDatasetTableRows,
  type DatasetTableRow,
  type DatasetTableRowActionBuilder,
  type DatasetTableRowClickHandler,
} from "./DatasetTableRow";

type BookmarksTableSourceOptions = {
  pageSize: number;
  rowActionsBuilder: DatasetTableRowActionBuilder;
  rowClickHandler: DatasetTableRowClickHandler;
  resolveErrorMessage: (error: unknown) => string;
};

// 북마크 목록 source. 내가 담아 둔 공용 Dataset(GET /v1/me/bookmarks)을 조회한다. 응답이 flat
// Dataset 이라 별도 행 타입 없이 Dataset 목록 컬럼·카드 계약을 그대로 함께 쓴다. 검색·필터 criteria 는
// 베이스가 소유하고, 서버가 담긴 범위 안에서 좁힌다(Dataset 목록과 같은 파라미터 계약).
// 빼기는 dataset_uuid 로 대상을 지정하고 행을 즉시 제거한다. 공용 Dataset 자체는 바꾸지 않는다.
export class BookmarksTableSource extends DatasetCriteriaTableSource {
  private readonly rowActionsBuilder: DatasetTableRowActionBuilder;
  private readonly rowClickHandler: DatasetTableRowClickHandler;

  constructor({
    pageSize,
    rowActionsBuilder,
    rowClickHandler,
    resolveErrorMessage,
  }: BookmarksTableSourceOptions) {
    super({ initialPageSize: pageSize, resolveErrorMessage });
    this.rowActionsBuilder = rowActionsBuilder;
    this.rowClickHandler = rowClickHandler;
  }

  async removeBookmark(row: DatasetTableRow): Promise<void> {
    await removeBookmark(row.uuid);
    this.removeRow(row.getRowId());
  }

  protected override async onPage(
    req: DataTablePageReq,
    { signal }: DataTablePageOptions,
  ): Promise<DataTablePageResp<DatasetTableRow>> {
    const response = await listBookmarks(
      {
        page: req.page,
        size: req.size,
        ...this.criteriaQuery(),
        ...this.sortQuery(),
      },
      { signal },
    );
    return {
      rows: createDatasetTableRows(response.items, this.rowActionsBuilder, this.rowClickHandler),
      total: response.total,
      page: response.page,
      size: response.size,
    };
  }
}
